import { Link } from 'react-router-dom';

export default function Welcome() {
  return (
    <>
      <section className="hero">
        <picture style={{ display: 'contents' }}>
          <source media="(max-width: 680px)" srcSet={`${process.env.PUBLIC_URL}/images/bg2-mobile.webp`} />
          <img
            src={`${process.env.PUBLIC_URL}/images/bg2.webp`}
            alt="Ejecta Landscapes work"
            className="hero-img"
            width="1440"
            height="1080"
            fetchpriority="high"
          />
        </picture>
        <div className="hero-content">
          <h2>Your Yard, <span>Transformed.</span></h2>
          <p>
            Professional landscaping services for residential and commercial properties.
            We take pride in every lawn, garden, and outdoor space we touch.
          </p>
          <div className="hero-actions">
            <Link to="/contact" className="btn">Get a Free Quote</Link>
            <Link to="/my-works" className="btn btn-outline">See Our Work</Link>
          </div>
        </div>
      </section>

      <section className="about-section">
        <div className="about-content about-content--right">
          <h2>About Ejecta Landscapes</h2>
          <p>
            Ejecta Landscapes specialises in hardscape design and construction — think patios,
            retaining walls, paving, and outdoor structures built to last. With over 10 years
            of hands-on experience, we know how to turn underused outdoor spaces into
            something genuinely impressive.
          </p>
          <p>
            We work directly with you from the first consultation through to the final finish,
            giving you a personalised service that big companies simply can't match.
          </p>
          <p>
            Ready to get started?{' '}
            <Link to="/contact" className="inline-link">Contact us today</Link> or{' '}
            <Link to="/services" className="inline-link">explore our services</Link>.
          </p>
        </div>
        <picture style={{ display: 'contents' }}>
          <source media="(max-width: 680px)" srcSet={`${process.env.PUBLIC_URL}/images/bg3-mobile.webp`} />
          <img
            src={`${process.env.PUBLIC_URL}/images/bg3.webp`}
            alt="Ejecta Landscapes work"
            className="about-img about-img--right"
            width="1440"
            height="1080"
            loading="lazy"
            decoding="async"
          />
        </picture>
      </section>

      <section className="why-section">
        <picture style={{ display: 'contents' }}>
          <source media="(max-width: 680px)" srcSet={`${process.env.PUBLIC_URL}/images/bg1-mobile.webp`} />
          <img
            src={`${process.env.PUBLIC_URL}/images/bg1.webp`}
            alt="Ejecta Landscapes team"
            className="about-img"
            width="1440"
            height="1080"
            loading="lazy"
            decoding="async"
          />
        </picture>
        <div className="about-content about-content--right">
          <h2>Why Choose Us?</h2>
          <p>
            With 10+ years of experience in hardscape construction, we bring a level of
            expertise and attention to detail that shows in every finished project — from
            small patio installs to large-scale outdoor transformations.
          </p>
          <p>
            You won't be dealing with a call centre or a rotating crew. We offer a genuinely
            personalised service, working closely with you to understand your space, your
            style, and your budget — then delivering results you'll be proud of.
          </p>
          <p>
            No shortcuts, no subcontractors, no surprises — just quality hardscape work
            done right.
          </p>
        </div>
      </section>
    </>
  );
}
